import { AppWindow, Cpu, type LucideIcon, MonitorPlay, Server, Tv, TvMinimal } from 'lucide-react'
import { cn } from '@/lib/utils'
import { platformLabel } from '../lib/status'

const ICONS: Record<string, { icon: LucideIcon; tint: string }> = {
  linux: { icon: Server, tint: 'bg-primary/10 text-primary' },
  raspberry_pi: { icon: Cpu, tint: 'bg-danger/10 text-danger' },
  windows: { icon: AppWindow, tint: 'bg-info/12 text-info' },
  android_tv: { icon: Tv, tint: 'bg-success/12 text-success' },
  tizen: { icon: TvMinimal, tint: 'bg-info/12 text-info' },
  webos: { icon: MonitorPlay, tint: 'bg-warning/15 text-warning' },
}

export function PlatformIcon({ platform, className, size = 'default' }: { platform: string | null | undefined; className?: string; size?: 'sm' | 'default' | 'lg' }) {
  const entry = (platform && ICONS[platform]) || { icon: Cpu, tint: 'bg-muted text-muted-foreground' }
  const Icon = entry.icon
  const box = size === 'sm' ? 'size-6 rounded-md' : size === 'lg' ? 'size-11 rounded-xl' : 'size-8 rounded-lg'
  const glyph = size === 'sm' ? 'size-3.5' : size === 'lg' ? 'size-5' : 'size-4'
  return (
    <span className={cn('flex shrink-0 items-center justify-center', box, entry.tint, className)} title={platformLabel(platform)}>
      <Icon className={glyph} />
      <span className="sr-only">{platformLabel(platform)}</span>
    </span>
  )
}
